/**
 * Mirrors ApplicationController::IDLE_TIMEOUT. The server is authoritative: it
 * stores the last activity in the cache under the jti and answers 401 once the
 * window has passed, so nothing here can keep a session alive.
 *
 * The point of tracking it on the client is the opposite — not leaving a UI
 * open that looks logged in while the session behind it is already gone. The
 * clock therefore has to follow the same rule as the server: it resets on a
 * *request*, not on mouse movement. A user who reads a page for fifteen minutes
 * without triggering one is logged out, exactly as the server sees it.
 */
export const IDLE_TIMEOUT_MS = 14 * 60 * 1000;

/** Checked often enough that the UI reacts promptly, rarely enough to be free. */
export const IDLE_POLL_MS = 15 * 1000;

let lastRequestAt = Date.now();

export function markRequest(): void {
  lastRequestAt = Date.now();
}

export function idleMs(): number {
  return Date.now() - lastRequestAt;
}

export function isIdleExpired(): boolean {
  return idleMs() >= IDLE_TIMEOUT_MS;
}
